import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import {
  Box,
  Card,
  CardContent,
  Button,
  CircularProgress,
  Alert,
} from '@mui/material';
import { useSettingsStore } from '../../stores/root_store';
import { EmailPreferencesForm } from '../../components/settings/EmailPreferencesForm';
import type { EmailPreferences } from '../../types';

export const SettingsEmail = observer(() => {
  const settingsStore = useSettingsStore();
  const [emailPrefs, setEmailPrefs] = useState<EmailPreferences | null>(null);
  const [hasChanges, setHasChanges] = useState(false);

  useEffect(() => {
    if (settingsStore.settings) {
      setEmailPrefs(settingsStore.settings.email_preferences);
      setHasChanges(false);
    }
  }, [settingsStore.settings]);

  const handleSave = async () => {
    if (!emailPrefs || !settingsStore.settings) return;
    const success = await settingsStore.updateSettings({
      ...settingsStore.settings.profile,
      ...emailPrefs,
    });
    if (success) {
      setHasChanges(false);
    }
  };

  if (!emailPrefs) {
    return null;
  }

  return (
    <Card>
      <CardContent>
        {settingsStore.error && (
          <Alert
            severity="error"
            sx={{ mb: 2 }}
            onClose={() => settingsStore.clearError()}
          >
            {settingsStore.error}
          </Alert>
        )}

        <EmailPreferencesForm
          preferences={emailPrefs}
          onChange={(p) => {
            setEmailPrefs(p);
            setHasChanges(true);
          }}
          disabled={settingsStore.saving}
        />

        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            onClick={handleSave}
            disabled={!hasChanges || settingsStore.saving}
          >
            {settingsStore.saving ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              'Save Changes'
            )}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
});
